import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { Link } from 'gatsby';

import MenuIcon from '@images/icons/24/menu-icon.inline.svg';
import CloseIcon from '@images/icons/24/close-icon.inline.svg';
import links from '@data/links.json';
import * as css from './MobileMenu.module.css';

const MobileMenu = () => {
  const [navOpen, setNavOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setNavOpen(false);
    }
  };

  const toggleMobileNav = () => setNavOpen((value) => !value);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <section ref={ref} className={css.mobileMenu}>
      <button
        type="button"
        aria-label="Mobile Navigation Menu"
        onClick={toggleMobileNav}
        className={cn(css.mobileMenuButton, {
          [css.mobileMenuButtonActive]: navOpen,
        })}
      >
        <MenuIcon className={cn('block', { hidden: navOpen })} fill="white" />
        <CloseIcon
          className={cn({ hidden: !navOpen, block: navOpen })}
          fill="white"
        />
        <span className="text-sm ml-3 font-medium">Menu</span>
      </button>
      <nav
        className={cn(css.mobileNav, {
          hidden: !navOpen,
          block: navOpen,
        })}
      >
        <div className={css.mobileNav__inner}>
          <Link
            className={css.mobileNav__item}
            to={links.home}
            activeClassName={css.mobileNav__itemActive}
          >
            Home
          </Link>
          <Link
            className={css.mobileNav__item}
            to={links.ourPhilosophy}
            activeClassName={css.mobileNav__itemActive}
          >
            Our Philosophy
          </Link>
          <Link
            className={css.mobileNav__item}
            to={links.financialPlanning}
            activeClassName={css.mobileNav__itemActive}
          >
            Financial Planning
          </Link>
          <Link
            className={css.mobileNav__item}
            to={links.investmentManagement}
            activeClassName={css.mobileNav__itemActive}
          >
            Investment Management
          </Link>
          <Link
            className={css.mobileNav__item}
            to={links.education}
            activeClassName={css.mobileNav__itemActive}
          >
            Education
          </Link>
          <Link
            className={css.mobileNav__item}
            to={links.contact}
            activeClassName={css.mobileNav__itemActive}
          >
            Contact
          </Link>
        </div>
      </nav>
    </section>
  );
};

export default MobileMenu;
